import React from 'react';
import { useDeductionsList } from './hooks/useDeductionsList';
import SharedFilters from '../../../components/SharedFilters';
import AppPagination from '../../../components/AppPagination';
import DeductionsTable from './components/DeductionsTable';

export default function DeductionsListScreen() {
  const { state, actions } = useDeductionsList();

  const payHeadDropdownOptions = [
    { value: '', label: 'All Pay Heads' },
    ...(state.dynamicOptions.payHeads || []).map((p) => ({
      value: String(p.value),
      label: p.label,
    })),
  ];

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner with Title on Left */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            Emp Deductions
          </h1>
          <p className="text-xs text-on-surface-variant font-medium mt-1">
            Manage and track employee salary deductions, penalty recoveries, and advances.
          </p>
        </div>
      </section>

      {/* Shared Filters Component */}
      <SharedFilters
        searchText={state.employeeFilter}
        setSearchText={actions.setEmployeeFilter}
        searchField="Employee"
        datePreset={state.datePreset}
        setDatePreset={actions.setDatePreset}
        datePresetOptions={state.datePresetOptions}
        fromDate={state.fromDate}
        toDate={state.toDate}
        setFromDate={actions.setFromDate}
        setToDate={actions.setToDate}
        fromEmpId={state.fromEmpId}
        setFromEmpId={actions.setFromEmpId}
        tillEmpId={state.tillEmpId}
        setTillEmpId={actions.setTillEmpId}
        fromAmount={state.fromAmount}
        setFromAmount={actions.setFromAmount}
        tillAmount={state.tillAmount}
        setTillAmount={actions.setTillAmount}
        payHeadFilter={state.payHeadFilter}
        setPayHeadFilter={actions.setPayHeadFilter}
        payHeadOptions={payHeadDropdownOptions}
        showStatus={false}
        onSearch={actions.handleSearch}
        onReset={actions.resetFilters}
        visibleAccordionFilters={['datePreset', 'fromDate', 'toDate', 'payHead', 'empIdRange', 'amountRange']}
        tools={state.tools}
        onToolSelect={actions.handleToolSelect}
      />

      {/* Table Section */}
      <section className="space-y-4">
        <DeductionsTable
          records={state.records}
          isLoading={state.isLoading}
          onDelete={actions.handleDelete}
          onResetFilters={actions.resetFilters}
        />

        {/* Table Footer with Pagination */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {state.totalCount === 0 ? 0 : (state.page - 1) * state.pageSize + 1} to{' '}
            {Math.min(state.page * state.pageSize, state.totalCount)} of {state.totalCount} entries
          </p>
          <AppPagination
            page={state.page}
            totalPages={state.totalPages}
            onPageChange={actions.setPage}
            onPrevious={() => actions.setPage((p) => Math.max(p - 1, 1))}
            onNext={() => actions.setPage((p) => Math.min(p + 1, state.totalPages))}
            canPrevious={state.page > 1}
            canNext={state.page < state.totalPages}
          />
        </div>
      </section>
    </div>
  );
}
